import React, { useRef, useState } from "react";

interface DropzoneProps {
    label: string;
    file: File | null;
    previewUrl?: string | null;
    onFileChange: (file: File | null) => void;
    hint?: string;
    accept?: string;
    multiple?: boolean;
}

const Dropzone: React.FC<DropzoneProps> = ({
                                               label,
                                               file,
                                               previewUrl,
                                               onFileChange,
                                               hint = "Перетащите файл сюда или нажмите для выбора",
                                               accept = "image/*",
                                               multiple = false,
                                           }) => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [isDragOver, setIsDragOver] = useState(false);

    const handleOpenFileDialog = () => {
        inputRef.current?.click();
    };

    const handleFiles = (fileList: FileList | null) => {
        if (!fileList || fileList.length === 0) {
            return;
        }

        const nextFile = fileList[0];
        onFileChange(nextFile);
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragOver(false);
        handleFiles(event.dataTransfer.files);
    };

    return (
        <div className="dropzone-field">
            <span className="ui-label">{label}</span>

            <div
                className={`dropzone ${isDragOver ? "dropzone-active" : ""}`}
                onClick={handleOpenFileDialog}
                onDragEnter={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setIsDragOver(true);
                }}
                onDragOver={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    event.dataTransfer.dropEffect = "copy";
                    setIsDragOver(true);
                }}
                onDragLeave={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setIsDragOver(false);
                }}
                onDrop={handleDrop}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleOpenFileDialog();
                    }
                }}
            >
                <input
                    ref={inputRef}
                    className="dropzone-input"
                    type="file"
                    accept={accept}
                    multiple={multiple}
                    onChange={(event) => handleFiles(event.target.files)}
                />

                {previewUrl ? (
                    <div className="dropzone-preview-wrap">
                        <img className="dropzone-preview-image" src={previewUrl} alt="Предпросмотр" />
                        <div className="dropzone-preview-meta">
                            <span className="dropzone-file-name">{file?.name ?? "Текущее изображение"}</span>
                            <button
                                type="button"
                                className="dropzone-remove-button"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onFileChange(null);
                                }}
                            >
                                Удалить
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="dropzone-placeholder">
                        <div className="dropzone-placeholder-icon">+</div>
                        <p className="dropzone-placeholder-title">Загрузка изображения</p>
                        <p className="dropzone-placeholder-text">{hint}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dropzone;
